import React from "react";
import SEOMeta from "../../components/SEOMeta";
import { WebPaths } from "../../../../routes/data";
import { SVLogoSquare } from "../../../../images";
import Banner from "./components/Banner";
import VisaCategories from "./components/VisaCategories";
import TailoredSolutions from "./components/TailoredSolutions";
import Testimonials from "./components/Testimonials";

const ForVisaServices = () => {
  return (
    <>
      <SEOMeta
        title="Visa Services | SeamlessVisa"
        description="Navigate the complexities of visa applications with confidence. SeamlessVisa guides you through every step with AI precision and expert oversight."
        canonicalUrl={`https://www.seamlessvisa.com${WebPaths.VisaServices}`}
        url={`https://www.seamlessvisa.com${WebPaths.VisaServices}`}
        siteName="SeamlessVisa"
        publisher="https://www.facebook.com/share/1BhLA5r2Ac/"
        imageUrl={SVLogoSquare}
        imageWidth="1920"
        imageHeight="1080"
        imageType="image/png"
        twitterCard="summary_large_image"
        twitterTitle="Visa Services | SeamlessVisa"
        twitterDescription="Navigate the complexities of visa applications with confidence. SeamlessVisa guides you through every step with AI precision and expert oversight."
        twitterSite="@SeamlessVisa_"
      />
      <div className="flex flex-col gap-0 relative overflow-hidden">
        <Banner />
        <VisaCategories />
        <TailoredSolutions />
        <Testimonials />
        {/* <VisaServicesFAQ />
        <VisaServicesCTA /> */}
      </div>
    </>
  );
};

export default ForVisaServices;
